import { Row } from 'antd';
import styled from 'styled-components';

export const SequencingFilterBody = styled.div`
  padding: 22px 16px 16px;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SequencingDatePickerWrapper = styled(Row)`
  align-items: center;
  gap: 10px;

  .divider {
    width: 8px;
    height: 2px;
    background: var(--gray);
  }
`;

export const SendForSequencingContent = styled.div`
  padding: 40px;
  padding-bottom: 16px;
`;
